export function getPathToDashboard(dashboardId: string) {
  return `/vortex/analytics/dashboards/${dashboardId}`;
}

export function getDashboardIdFromPath(path: string) {
  const matchAttempt = path.match(/analytics\/dashboards\/(.*)$/);
  if (!matchAttempt) return undefined;
  return matchAttempt[1];
}
